// components/DataExport/DataExport.js
import React, { useState } from 'react';
import api from '../../services/api';
import { Input } from '../UI/Input.js';
import { Button } from '../UI/Button.js';
import { Dropdown } from '../UI/Dropdown.js';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';

const DataExport = () => {
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');
  const [pin, setPin] = useState('');

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years
  const months = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12
  const days = Array.from({ length: 31 }, (_, i) => i + 1); // 1-31

  const handleExport = async () => {
    try {
      let url = `/export/employee/${pin}`;
      const params = new URLSearchParams();
      if (year) params.append('year', year);
      if (month) params.append('month', month);
      if (day) params.append('day', day);
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      const response = await api.get(url, { responseType: 'blob' });
      // Create a download link
      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlBlob;
      // Use the filename from the Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'download.xlsx'; // Default filename
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename\*?="?([^";]+)"?/);
        if (filenameMatch && filenameMatch.length > 1) {
          filename = filenameMatch[1];
        }
      }
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error('Data export failed', error);
      alert('Data export failed. Please check the inputs.');
    }
  };

  return (
    <div>
      <h2>Exportar datos de fichaje electronico</h2>
      <FormContainer>
        <FullWidth>
          <Dropdown value={year} onChange={(e) => setYear(e.target.value)} required >
            <option value="">Año</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Dropdown value={month} onChange={(e) => setMonth(e.target.value)} required >
            <option value="">Mes</option>
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Dropdown value={day} onChange={(e) => setDay(e.target.value)}>
            <option value="">Día</option>
            {days.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Input type="text" placeholder="PIN" value={pin} onChange={(e) => setPin(e.target.value)} required />
        </FullWidth>
        <FullWidth>
          <Button onClick={handleExport}>Export</Button>
        </FullWidth>
      </FormContainer>
    </div>
  );
};

export default DataExport;